/**
 * Default fallback data for global/list/info API responses
 * Used when the API returns non-200 status codes or encounters errors
 */

const DEFAULT_LIST_INFO = {
  resources: [
    {
      "ID": 1,
      "Title": "Total",
      "NumberValue": "0",
      "Description": null,
      "Class": "ss-primary-font-color",
      "Border": "border-left-purple",
      "UIName": null,
      "IsCurrency": false,
      "IsHighlightSection": false,
      "SubText": null
    },
    {
      "ID": 2,
      "Title": "New",
      "NumberValue": "0",
      "Description": null,
      "Class": "ss-orange-font-color",
      "Border": "border-left-orange",
      "UIName": null,
      "IsCurrency": false,
      "IsHighlightSection": false,
      "SubText": null
    },
    {
      "ID": 3,
      "Title": "Waiting",
      "NumberValue": "0",
      "Description": null,
      "Class": "ss-primary-blue-font-color",
      "Border": "border-left-blue",
      "UIName": null,
      "IsCurrency": false,
      "IsHighlightSection": false,
      "SubText": null
    },
    {
      "ID": 4,
      "Title": "Ready for Pickup",
      "NumberValue": "0",
      "Description": null,
      "Class": "ss-green-font-color",
      "Border": "border-left-green",
      "UIName": null,
      "IsCurrency": false,
      "IsHighlightSection": false,
      "SubText": null
    },
    {
      "ID": 5,
      "Title": "Total - New",
      "NumberValue": "$0.00",
      "Description": null,
      "Class": "ss-danger-light-bg",
      "Border": "",
      "UIName": null,
      "IsCurrency": false,
      "IsHighlightSection": true,
      "SubText": null
    },
    {
      "ID": 6,
      "Title": "Total - Waiting",
      "NumberValue": "$0.00",
      "Description": null,
      "Class": "ss-danger-light-bg",
      "Border": "",
      "UIName": null,
      "IsCurrency": false,
      "IsHighlightSection": true,
      "SubText": null
    }
  ]
};

export default DEFAULT_LIST_INFO;